/**
 * Local dev server (`ng serve`) pointing at the AWS staging API.
 * Use: `ng serve --configuration=staging`
 */
export const environment = {
  production: false,
  apiBaseUrl: 'https://api.staging.lumen.creativefusion.net'
};
